import { ReactNode } from 'react';

interface AuthButtonProps {
  children: ReactNode;
  type?: 'button' | 'submit';
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'outlined' | 'light';
}

export const AuthButton = ({
  children,
  type = 'button',
  onClick,
  loading,
  disabled,
  variant = 'primary',
}: AuthButtonProps) => {
  const base =
    'w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-green01 text-black hover:bg-green02 disabled:bg-green01/30 disabled:text-black/40',
    outlined:
      'border border-green01 text-green01 bg-transparent hover:bg-green01/5 disabled:border-green01/30 disabled:text-green01/40',
    light: 'bg-[#F2F4EE] text-black hover:bg-white disabled:bg-white/30 disabled:text-black/40',
  };

  return (
    <button type={type} onClick={onClick} disabled={disabled || loading} className={`${base} ${variants[variant]}`}>
      {loading && <div className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin" />}
      {children}
    </button>
  );
};
